import { ExternalFile } from "./external-file";

export class DatedFiles{

  public year: number;
  public files: Array<ExternalFile> = [];

}
